/* HB 2026-10-12 (round 31, audit item 8): the delivery-date script, moved out of snippets/delivery-estimate.liquid.
   It used to be printed inline wherever the snippet renders (the cart drawer on every page, the sticky add-to-cart on
   product pages, twice on the cart page), and every copy ran: each set its own whole-page observer and redid the same
   date work on every change to the page. As a module it is downloaded once, cached, and runs once per page; what it
   writes is unchanged (the same code, the Liquid comments dropped). */
(function() {

    let isUpdating = false;

    async function updateDeliveryDate() {

        if (isUpdating) return;

        const elements = document.querySelectorAll('.custom-delivery-date');
         

        

        isUpdating = true;

        try {

            /*
            ============================================
            SHIPPING MATRIX
            ============================================
            */

            const SHIPPING_RULES = {
                DKK: { min: 1, max: 2 },
                EUR: { min: 1, max: 2 },
                GBP: { min: 1, max: 3 },
                CHF: { min: 1, max: 3 },
                SEK: { min: 1, max: 2 },
                NOK: { min: 1, max: 2 },
                PLN: { min: 1, max: 2 },

                AED: { min: 1, max: 3 },
                SAR: { min: 1, max: 3 },

                CAD: { min: 1, max: 3 },

                MXN: { min: 1, max: 3 },

                AUD: { min: 1, max: 3 },
                HKD: { min: 1, max: 3 },
                SGD: { min: 1, max: 3 },
                JPY: { min: 1, max: 3 },
                KRW: { min: 1, max: 3 },
                CNY: { min: 1, max: 3 }
            };

            /*
            ============================================
            GET SHOPIFY MARKET CURRENCY
            ============================================
            */

            let currency = 'USD';

            if (window.Shopify?.currency?.active) {
                currency = Shopify.currency.active;
            } else if (window.Shopify?.checkout?.currency) {
                currency = Shopify.checkout.currency;
            }

            /*
            ============================================
            GEO IP LOOKUP
            ============================================
            */

            function getUserCountry() {
                try {
                const cachedCountry = localStorage.getItem("user_country");
                const cachedTime = localStorage.getItem("user_country_time");

                if (
                    cachedCountry &&
                    cachedTime &&
                    Date.now() - parseInt(cachedTime, 10) < 86400000
                ) {
                    return cachedCountry;
                }

                const country =
                    window.HBLocalization?.country ||
                    window.Shopify?.country ||
                    "US";

                const finalCountry = country.toUpperCase();

                localStorage.setItem("user_country", finalCountry);
                localStorage.setItem("user_country_time", Date.now().toString());

                return finalCountry;
                } catch (e) {
                return "US";
                }
            }

            const userCountry =  getUserCountry();

            /*
            ============================================
            SHIPPING RANGE
            ============================================
            */

            function getShippingRange(currency, country) {

                /*
                USD SPECIAL LOGIC
                */

                if (currency === 'USD') {

                    return country === 'US'
                        ? { min: 1, max: 3 }
                        : { min: 1, max: 3 };
                }

                /*
                STANDARD RULES
                */

                if (SHIPPING_RULES[currency]) {
                    return SHIPPING_RULES[currency];
                }

                /*
                FALLBACK
                */

                return { min: 1, max: 3 };
            }

            const shippingRange = getShippingRange(currency, userCountry);

            /*
            ============================================
            HOLIDAYS
            ONLY FOR SHIPPING DATE
            ============================================
            */

            async function getHolidays(countryCode) {

                if (!countryCode) return [];

                const year = new Date().getFullYear();

                const cacheKey = `holidays_${countryCode}_${year}`;

                const cached = localStorage.getItem(cacheKey);

                if (cached) {
                    return JSON.parse(cached);
                }

                try {

                    const response = await fetch(
                        `https://date.nager.at/api/v3/PublicHolidays/${year}/${countryCode}`
                    );

                    if (!response.ok) return [];

                    const data = await response.json();

                    const dates = data.map(h => h.date);

                    localStorage.setItem(cacheKey, JSON.stringify(dates));

                    return dates;

                } catch (e) {

                    return [];
                }
            }

            /*
            SHIPPING COUNTRY
            Denmark warehouse
            */

            const holidays = await getHolidays('DK');

            /*
            ============================================
            HELPERS
            ============================================
            */

            function isWeekend(date) {

                const day = date.getDay();

                return day === 0 || day === 6;
            }

            function isHoliday(date, holidays) {

                const formatted = date.toISOString().split('T')[0];

                return holidays.includes(formatted);
            }

            /*
            ============================================
            CET CUTOFF
            ============================================
            */

            let baseDate = new Date();

            const cetHour = parseInt(
                new Intl.DateTimeFormat('en-US', {
                    timeZone: 'Europe/Copenhagen',
                    hour: 'numeric',
                    hour12: false
                }).format(new Date()),
                10
            );

            /*
            AFTER 14:00 CET
            START NEXT DAY
            */

            if (cetHour >= 12) {

                baseDate.setDate(baseDate.getDate() + 1);
            }

            /*
            ============================================
            SHIPPING DATE
            HOLIDAYS ONLY APPLY HERE
            ============================================
            */

            let shippingDate = new Date(baseDate.getTime());

            while (
                isWeekend(shippingDate) ||
                isHoliday(shippingDate, holidays)
            ) {
                shippingDate.setDate(shippingDate.getDate() + 1);
            }

            /*
            ============================================
            ADD BUSINESS DAYS
            ONLY SKIP WEEKENDS
            HOLIDAYS DO NOT AFFECT TRANSIT
            ============================================
            */

            function addBusinessDays(date, days) {

                const result = new Date(date.getTime());

                let added = 0;

                while (added < days) {

                    result.setDate(result.getDate() + 1);

                    /*
                    ONLY SKIP WEEKENDS
                    */

                    if (!isWeekend(result)) {

                        added++;
                    }
                }

                return result;
            }

            /*
            ============================================
            DELIVERY RANGE
            ============================================
            */

            const minDate = addBusinessDays(
                shippingDate,
                shippingRange.min
            );

            const maxDate = addBusinessDays(
                shippingDate,
                shippingRange.max
            );

            /*
            ============================================
            FORMAT
            ============================================
            */

            

            function formatDeliveryRange(minDate, maxDate, isCartDrawer = false, targetEl = null) {

                const minMonth = minDate.toLocaleDateString(undefined, {
                    month: 'long'
                });

                const maxMonth = maxDate.toLocaleDateString(undefined, {
                    month: 'long'
                });

                const minDay = minDate.getDate();
                const maxDay = maxDate.getDate();

                /*
                BOLD MONTH + DATES
                */

                const formattedDate = (minMonth === maxMonth)
                    ? `<strong>${minMonth} ${minDay} – ${maxDay}</strong>`
                    : `<strong>${minMonth} ${minDay} – ${maxMonth} ${maxDay}</strong>`;

                const shipItem = [...document.querySelectorAll(".cart-items__table-row, [data-hb-line]")].map(row => row.getAttribute("data-ship-item")).find(value => value);
                const arrivalDate = shipItem ? `<strong>${shipItem}</strong>` : formattedDate;
                
                /*
                DIFFERENT TEXT FOR CART
                HB 2026-10-08: the line now compares the cart total with the threshold. Until today it only
                looked at the threshold, so a 2,320 DKK cart still read "Free shipping over 900 DKK".
                Threshold and total come from the data attributes Liquid renders on the element (minor units,
                cart currency, refreshed with every cart re-render); the window object and the fixed rates
                stay as fallbacks for the markets where the hidden shipping-fee product has no price.
                */
                const ship_price = window.HBShippingThreshold ? window.HBShippingThreshold.liquidPrice : null;
                const rates = {  USD: 200,EUR: 180, DKK: 900};
                const currentCode = Shopify.currency.active;
                const value = rates[currentCode] ?? rates.DKK;

                const thresholdMinor = targetEl ? Number(targetEl.dataset.hbThreshold) : NaN;
                const cartTotalMinor = targetEl ? Number(targetEl.dataset.hbCartTotal) : NaN;
                let thresholdMajor;
                if (Number.isFinite(thresholdMinor) && thresholdMinor > 0) {
                    thresholdMajor = thresholdMinor / 100;
                } else if (ship_price !== null && ship_price !== undefined && ship_price !== '') {
                    thresholdMajor = Number(ship_price);
                } else {
                    thresholdMajor = value;
                }
                const overThreshold = !(thresholdMajor > 0) || (Number.isFinite(cartTotalMinor) && cartTotalMinor >= thresholdMajor * 100);

                const shippingText = overThreshold
                    ? `Free shipping - arrives ${arrivalDate}`
                    : `Free shipping over <strong>${thresholdMajor} ${currentCode}</strong> - arrives ${arrivalDate}`;

                const prefix = isCartDrawer
                     ? shippingText
                    : `Order now - arrives ${formattedDate}`;

                return `${prefix}`;
            }

           /*
            ============================================
            UPDATE PRODUCT PAGE
            ============================================
            */

            document.querySelectorAll('.product-delivery-date')
                .forEach(el => {
                    const text = formatDeliveryRange(
                        minDate,
                        maxDate,
                        false
                    );

                    if (el.innerHTML !== text) {

                        el.innerHTML = text;
                        el.style.opacity = '1';
                    }
                });

            /*
            ============================================
            UPDATE CART DRAWER
            ============================================
            */

            document.querySelectorAll('.cart-delivery-date')
                .forEach(el => {

                    const text = formatDeliveryRange(
                        minDate,
                        maxDate,
                        true,
                        el
                    );

                    if (el.innerHTML !== text) {

                        el.innerHTML = text;
                        el.style.opacity = '1';
                    }
                });

            /*
            ============================================
            HB 2026-10-08: THE CART DRAWER'S TRUST ROW
            "Arrives Oct 12 – 13", from the same two dates as the lines above
            (snippets/hb-cart-footer.liquid; assets/hb-cart.js re-applies it after a re-render)
            ============================================
            */

            {
                const shortMonth = (d) => d.toLocaleDateString('en-US', { month: 'short' });
                const preorderShip = [...document.querySelectorAll('.cart-items__table-row, [data-hb-line]')]
                    .map(row => row.getAttribute('data-ship-item')).find(value => value);
                let arrives;
                if (preorderShip) {
                    arrives = `Arrives ${preorderShip}`;
                } else if (shortMonth(minDate) === shortMonth(maxDate)) {
                    arrives = minDate.getDate() === maxDate.getDate()
                        ? `Arrives ${shortMonth(minDate)} ${minDate.getDate()}`
                        : `Arrives ${shortMonth(minDate)} ${minDate.getDate()} – ${maxDate.getDate()}`;
                } else {
                    arrives = `Arrives ${shortMonth(minDate)} ${minDate.getDate()} – ${shortMonth(maxDate)} ${maxDate.getDate()}`;
                }
                window.HBArrives = arrives;
                document.querySelectorAll('[data-hb-arrives]').forEach(el => {
                    if (el.textContent !== arrives) el.textContent = arrives;
                });
            }

                    } catch (error) {

                        console.error('Delivery Date Error:', error);

                    } finally {

                        isUpdating = false;
                    }
                }

    /*
    ============================================
    EVENTS
    ============================================
    */

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', updateDeliveryDate);
    } else {
        updateDeliveryDate();
    }

    document.addEventListener('cart:updated', () => {
        console.log("Updated");
        setTimeout(updateDeliveryDate, 200);
    });

    document.addEventListener('cart:added', () => {

        setTimeout(updateDeliveryDate, 500);
    });

    document.addEventListener('click', function(e) {

        if (
            e.target.closest(
                'a[href="/cart"], .cart-toggle, #cart-icon-bubble'
            )
        ) {
            setTimeout(updateDeliveryDate, 400);
        }
    });

    /*
    ============================================
    OBSERVER
    ============================================
    */

    const observer = new MutationObserver(() => {

        if (
            !isUpdating &&
            document.querySelector('.custom-delivery-date')
        ) {
            updateDeliveryDate();
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

})();
